import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { serverURL, postData } from "../../../../Services/Fetchnodeservices";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS (Same as before)
// ─────────────────────────────────────────────────────────────────────────────
const EditIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>);
const TrashIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" /></svg>);
const BackIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>);
const ClockIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>);
const LocationIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>);
const PhoneIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.574 2.81.7A2 2 0 0 1 22 16.92z" /></svg>);
const EmailIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-10 7L2 7" /></svg>);
const StarIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>);
const ImageIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>);
const DocumentIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>);
const IdCardIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/><circle cx="12" cy="10" r="3"/><path d="M7 15c0-2 3-3 5-3s5 1 5 3"/></svg>);
const BankIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="6" width="20" height="12" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/><line x1="16" y1="14" x2="18" y2="14"/></svg>);
const LicenseIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="8,8 16,8"/><polyline points="8,12 14,12"/><polyline points="8,16 12,16"/></svg>);
const TagIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>);
const PlusIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>);
const PercentIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 5L5 19M9 6.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0zM20 17.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0z"/></svg>);
const GiftIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>);
const ChevronLeftIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>);
const ChevronRightIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>);
const SpinnerIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" style={{ animation: "spin 0.8s linear infinite", transformOrigin: "center" }}/></svg>);

// ─────────────────────────────────────────────────────────────────────────────
// OFFER TABLE ROW COMPONENT (Removed Owner, Logo, Payment columns)
// ─────────────────────────────────────────────────────────────────────────────
const OfferTableRow = ({ offer, index, theme, onEdit, onDelete }) => {
  const getOfferColor = (type) => {
    if (type === 'discount') return "#3b82f6";
    if (type === 'percentage') return "#10b981";
    if (type === 'buy_get') return "#f59e0b";
    if (type === 'buy_get_x') return "#8b5cf6";
    return "#64748b";
  };

  const getOfferDescription = () => {
    if (offer.offer_type === 'discount') return `₹${offer.offer} OFF`;
    if (offer.offer_type === 'percentage') return `${offer.offer}% OFF`;
    if (offer.offer_type === 'buy_get') return `${offer.buy_quantity}+${offer.free_quantity}`;
    if (offer.offer_type === 'buy_get_x') return `${offer.buy_quantity}+Free`;
    return offer.offer_name;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "No expiry";
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const isExpired = offer.offer_end && new Date(offer.offer_end) < new Date();

  return (
    <tr style={{
      borderBottom: `1px solid ${theme === 'dark' ? "#1e2740" : "#e2e8f0"}`,
      transition: "background 0.2s",
      opacity: isExpired ? 0.5 : 1,
    }}
    onMouseEnter={(e) => e.currentTarget.style.background = theme === 'dark' ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.01)"}
    onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
    >
      <td style={{ padding: "6px 10px", fontSize: "11px", color: theme === 'dark' ? "#94a3b8" : "#6b7280", textAlign: "center" }}>
        {index + 1}
      </td>
      <td style={{ padding: "6px 10px", fontSize: "12px", fontWeight: 500, color: theme === 'dark' ? "#f1f5f9" : "#1e293b" }}>
        {offer.offer_name || "Unnamed Offer"}
      </td>
      <td style={{ padding: "6px 10px" }}>
        <span style={{
          padding: "2px 8px",
          borderRadius: "12px",
          fontSize: "9px",
          fontWeight: 600,
          background: `${getOfferColor(offer.offer_type)}15`,
          color: getOfferColor(offer.offer_type),
        }}>
          {offer.offer_type || "Unknown"}
        </span>
      </td>
      <td style={{ padding: "6px 10px", fontSize: "13px", fontWeight: 700, color: getOfferColor(offer.offer_type) }}>
        {getOfferDescription()}
      </td>
      <td style={{ padding: "6px 10px", fontSize: "10px", color: theme === 'dark' ? "#94a3b8" : "#6b7280" }}>
        {formatDate(offer.offer_start)}
      </td>
      <td style={{ padding: "6px 10px", fontSize: "10px", color: theme === 'dark' ? "#94a3b8" : "#6b7280" }}>
        {formatDate(offer.offer_end)}
      </td>
      <td style={{ padding: "6px 10px" }}>
        <span style={{
          padding: "2px 8px",
          borderRadius: "12px",
          fontSize: "9px",
          fontWeight: 600,
          background: offer.status === '1' ? "rgba(16,185,129,0.15)" : "rgba(148,163,184,0.12)",
          color: offer.status === '1' ? "#10b981" : "#94a3b8",
        }}>
          {offer.status === '1' ? "Active" : "Inactive"}
        </span>
      </td>
      <td style={{ padding: "6px 10px", textAlign: "right" }}>
        <div style={{ display: "flex", gap: "4px", justifyContent: "flex-end" }}>
          <button
            onClick={() => onEdit(offer)}
            style={{
              padding: "2px 8px",
              borderRadius: "4px",
              border: "none",
              background: "rgba(245,158,11,0.15)",
              color: "#f59e0b",
              cursor: "pointer",
              fontSize: "9px",
              display: "flex",
              alignItems: "center",
              gap: "2px",
            }}
          >
            <EditIcon style={{ width: "10px", height: "10px" }} /> Edit
          </button>
          <button
            onClick={() => onDelete(offer.id)}
            style={{
              padding: "2px 8px",
              borderRadius: "4px",
              border: "none",
              background: "rgba(239,68,68,0.15)",
              color: "#ef4444",
              cursor: "pointer",
              fontSize: "9px",
              display: "flex",
              alignItems: "center",
              gap: "2px",
            }}
          >
            <TrashIcon style={{ width: "10px", height: "10px" }} /> Del
          </button>
        </div>
      </td>
    </tr>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// RESTAURANT IMAGE COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const RestaurantImage = ({ picName, label, theme, size = "60px" }) => {
  const [imageError, setImageError] = useState(false);
  
  const getImageUrl = () => {
    if (!picName || picName.trim() === "" || picName === "NULL" || picName === "null") return null;
    let filename = picName;
    if (filename.includes('/')) filename = filename.split('/').pop();
    return `${serverURL}/public/uploadnew/upload/${filename}`;
  };
  
  const imageUrl = getImageUrl();
  
  if (!imageUrl || imageError) {
    return (
      <div style={{ 
        width: size, height: size, borderRadius: "10px", 
        background: theme === 'dark' ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.04)",
        display: "flex", alignItems: "center", justifyContent: "center",
        border: `1px dashed ${theme === 'dark' ? "#2a3145" : "#e5e7eb"}`
      }}>
        <DocumentIcon style={{ color: "#64748b", width: "20px", height: "20px" }} />
      </div>
    );
  }
  
  return (
    <img src={imageUrl} alt={label} onError={() => setImageError(true)}
      style={{ width: size, height: size, borderRadius: "10px", objectFit: "cover", border: `1px solid ${theme === 'dark' ? "#2a3145" : "#e5e7eb"}` }} />
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// DOCUMENT CARD COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const DocumentCard = ({ document, theme }) => (
  <div style={{
    background: theme === 'dark' ? "#0f1520" : "#f8fafc",
    borderRadius: "10px",
    border: `1px solid ${theme === 'dark' ? "#1e2740" : "#e2e8f0"}`,
    padding: "12px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}>
    <RestaurantImage picName={document.image} label={document.label} theme={theme} size="50px" />
    <div style={{ flex: 1 }}>
      <div style={{ fontSize: "10px", color: theme === 'dark' ? "#64748b" : "#6b7280", marginBottom: "2px", display: "flex", alignItems: "center", gap: "4px" }}>
        {document.icon} <span>{document.label}</span>
      </div>
      <div style={{ fontSize: "12px", fontWeight: 600, color: theme === 'dark' ? "#f1f5f9" : "#1e293b", marginBottom: "2px" }}>
        {document.number || "Not Provided"}
      </div>
      <div style={{
        fontSize: "9px", display: "inline-flex", alignItems: "center", gap: "4px",
        padding: "2px 6px", borderRadius: "10px",
        background: document.status === "Verified" ? "rgba(16,185,129,0.1)" : "rgba(245,158,11,0.1)",
        color: document.status === "Verified" ? "#10b981" : "#f59e0b",
      }}>
        <span style={{ width: "5px", height: "5px", borderRadius: "50%", background: document.status === "Verified" ? "#10b981" : "#f59e0b" }} />
        {document.status || "Pending"}
      </div>
    </div>
  </div>
);

// ─────────────────────────────────────────────────────────────────────────────
// BADGES
// ─────────────────────────────────────────────────────────────────────────────
const StatusBadge = ({ status, isDark }) => {
  const isActive = status === "Active";
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: "5px",
      padding: "3px 10px", borderRadius: "16px", fontSize: "10px",
      fontWeight: 600, background: isActive ? "rgba(16,185,129,0.15)" : "rgba(148,163,184,0.12)",
      color: isActive ? "#10b981" : "#94a3b8",
    }}>
      <span style={{ width: "5px", height: "5px", borderRadius: "50%", background: isActive ? "#10b981" : "#94a3b8" }} />
      {status}
    </span>
  );
};

const ReadyBadge = ({ ready, isDark }) => {
  const isReady = ready === "Yes";
  return (
    <span style={{
      padding: "3px 10px", borderRadius: "16px", fontSize: "10px",
      fontWeight: 600, background: isReady ? "rgba(16,185,129,0.15)" : "rgba(245,158,11,0.12)",
      color: isReady ? "#10b981" : "#f59e0b",
    }}>{ready}</span>
  );
};

const OnOffBadge = ({ value, isDark }) => {
  const isOn = value === "ON";
  return (
    <span style={{
      padding: "3px 10px", borderRadius: "16px", fontSize: "10px",
      fontWeight: 700, background: isOn ? "rgba(34,197,94,0.15)" : "rgba(148,163,184,0.12)",
      color: isOn ? "#22c55e" : "#94a3b8",
    }}>{value}</span>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// STAT CARD COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const StatCard = ({ value, label, icon, color, isDark }) => (
  <div style={{
    background: isDark ? "#141824" : "#ffffff",
    border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
    borderRadius: "14px",
    padding: "16px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}>
    <div style={{
      width: "40px", height: "40px", borderRadius: "10px",
      background: `${color}15`, display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <span style={{ fontSize: "20px" }}>{icon}</span>
    </div>
    <div>
      <div style={{ fontSize: "20px", fontWeight: 700, color: color }}>{value}</div>
      <div style={{ fontSize: "10px", color: isDark ? "#64748b" : "#6b7280" }}>{label}</div>
    </div>
  </div>
);

// ─────────────────────────────────────────────────────────────────────────────
// INFO ROW COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const InfoRow = ({ label, value, icon, isDark }) => (
  <div style={{
    display: "flex", alignItems: "center", gap: "10px",
    padding: "10px 14px", background: isDark ? "#0f1520" : "#f8fafc",
    borderRadius: "10px", border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
  }}>
    <div style={{ color: "#3b82f6", flexShrink: 0 }}>{icon}</div>
    <div>
      <div style={{ fontSize: "9px", color: isDark ? "#64748b" : "#6b7280", marginBottom: "1px" }}>{label}</div>
      <div style={{ fontSize: "12px", fontWeight: 500, color: isDark ? "#f1f5f9" : "#1e293b" }}>{value || "—"}</div>
    </div>
  </div>
);

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const RestaurantDetailPage = ({
  restaurant,
  onBack,
  onEdit,
  onDelete,
  onViewSchedule,
  onViewMenu,
  isDark
}) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("overview");
  const [allOffers, setAllOffers] = useState([]);
  const [loadingOffers, setLoadingOffers] = useState(false);
  const [offerError, setOfferError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offerSearch, setOfferSearch] = useState("");

  const [paymentData, setPaymentData] = useState([]);
const [paymentLoading, setPaymentLoading] = useState(false);
const [paymentSummary, setPaymentSummary] = useState({
  total: 0,
  completed: 0,
  pending: 0,
  platformFee: 0,
});


const fetchPayments = async () => {
  if (!restaurant?.restroId) return;

  try {
    setPaymentLoading(true);

    const response = await postData(
      "restaurant/paymentsbyrestaurant_id",
      {
        restaurant_id: restaurant.restroId,
      }
    );

    if (response?.status) {
      const list = response.data || [];

      let total = 0;
      let completed = 0;
      let pending = 0;

      list.forEach((item) => {
        const amount = Number(item.total_amount || 0);

        total += amount;

        if (
          item.payment_status === "completed" ||
          item.payment_status === "paid"
        ) {
          completed += amount;
        } else {
          pending += amount;
        }
      });

      setPaymentData(list);

      setPaymentSummary({
        total,
        completed,
        pending,
        platformFee: 0,
      });
    }
  } catch (e) {
    console.log(e);
  } finally {
    setPaymentLoading(false);
  }
};

useEffect(() => {
  fetchPayments();
}, [restaurant?.restroId]);

  // Listen for location updates when returning from LocationTabComponent
  useEffect(() => {
    const checkForLocationUpdate = () => {
      const updatedLocation = sessionStorage.getItem('updatedRestaurantLocation');
      if (updatedLocation) {
        try {
          const locationData = JSON.parse(updatedLocation);
          console.log("Location updated:", locationData);
          if (restaurant) {
            restaurant.address = locationData.address;
            restaurant.latitude = locationData.latitude;
            restaurant.longitude = locationData.longitude;
          }
          sessionStorage.removeItem('updatedRestaurantLocation');
        } catch (error) {
          console.error("Error parsing location update:", error);
        }
      }
    };
    checkForLocationUpdate();
  }, [restaurant]);

  const fetchAllOffers = async () => {
    if (!restaurant?.restroId) return;
    setLoadingOffers(true);
    setOfferError(null);
    try {
      const response = await postData("offers/offer", { designation_id: restaurant.restroId });
      let offersData = [];
      if (response && response.status === true && response.data) offersData = response.data;
      else if (Array.isArray(response)) offersData = response;
      else if (response?.data && Array.isArray(response.data)) offersData = response.data;
      setAllOffers(offersData);
    } catch (error) {
      console.error("Error fetching offers:", error);
      setOfferError(error.message || "Failed to fetch offers");
    } finally {
      setLoadingOffers(false);
    }
  };

  useEffect(() => {
    fetchAllOffers();
  }, [restaurant?.restroId]);

  // Filter offers based on search
  const filteredOffers = allOffers.filter(offer => 
    offer.offer_name?.toLowerCase().includes(offerSearch.toLowerCase()) ||
    offer.offer_type?.toLowerCase().includes(offerSearch.toLowerCase())
  );

  // Pagination
  const totalPages = Math.ceil(filteredOffers.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedOffers = filteredOffers.slice(startIndex, startIndex + rowsPerPage);

  const handleMenuTabClick = () => {
    sessionStorage.setItem('selectedRestaurant', JSON.stringify({
      designation_id: restaurant.restroId, restaurantName: restaurant.name
    }));
    navigate("/Dashboard/Menus", { state: { designation_id: restaurant.restroId, restaurantName: restaurant.name } });
  };

  const handleOrdersTabClick = () => {
    sessionStorage.setItem('selectedRestaurant', JSON.stringify({
      designation_id: restaurant.restroId, restaurantName: restaurant.name
    }));
    navigate("/Dashboard/RestaurantOrderHistory", { state: { designation_id: restaurant.restroId, restaurantName: restaurant.name } });
  };

  const handleGoToOffers = () => {
    sessionStorage.setItem('selectedRestaurant', JSON.stringify({
      designation_id: restaurant.restroId, restaurantName: restaurant.name
    }));
    navigate("/Dashboard/AddOffer", {
      state: { designation_id: restaurant.restroId, restaurantId: restaurant.restroId, restaurantName: restaurant.name }
    });
  };

  const handleLocationTabClick = () => {
    navigate("/Dashboard/LocationTabComponent", {
      state: {
        restroId: restaurant.restroId,
        restaurantName: restaurant.name,
        address: restaurant.address,
        latitude: restaurant.latitude,
        longitude: restaurant.longitude,
        isDark: isDark
      }
    });
  };

  const handleEditOffer = (offer) => {
    sessionStorage.setItem('selectedRestaurant', JSON.stringify({
      designation_id: restaurant.restroId, restaurantName: restaurant.name
    }));
    navigate("/Dashboard/AddOffer", {
      state: { designation_id: restaurant.restroId, restaurantId: restaurant.restroId, restaurantName: restaurant.name, editOffer: offer }
    });
  };

  const handleDeleteOffer = async (offerId) => {
    if (!window.confirm('Are you sure you want to delete this offer?')) return;
    try {
      const response = await postData("/offers/delete_offer", { id: offerId });
      if (response && response.status === true) {
        alert('Offer deleted successfully!');
        fetchAllOffers();
      } else {
        alert(response?.message || 'Failed to delete offer');
      }
    } catch (error) {
      alert('Failed to delete offer: ' + error.message);
    }
  };

  const handleEditClick = () => {
    console.log("Editing restaurant with data:", restaurant);
    navigate("/Dashboard/addrestaurant", {
      state: { 
        mode: "edit", 
        restaurantData: {
          id: restaurant.id || restaurant.restroId,
          old_id: restaurant.old_id || restaurant.id || restaurant.restroId,
          name: restaurant.name || "",
          organisation_name: restaurant.organisation_name || "",
          org_type: restaurant.org_type || "",
          pre: restaurant.pre || "",
          gender: restaurant.gender || "",
          contact: restaurant.contact || "",
          email: restaurant.email || "",
          password: restaurant.password || "",
          location: restaurant.location || "",
          city: restaurant.city || "",
          state: restaurant.state || "",
          postal: restaurant.postal || "",
          address: restaurant.address || "",
          latitude: restaurant.latitude || "",
          longitude: restaurant.longitude || "",
          owner_name: restaurant.owner_name || "",
          owner_mobile: restaurant.owner_mobile || "",
          other_person_name: restaurant.other_person_name || "",
          other_person_mobile: restaurant.other_person_mobile || "",
          bank_name: restaurant.bank_name || "",
          bank_branch: restaurant.bank_branch || "",
          bank_type: restaurant.bank_type || "",
          account_holder: restaurant.account_holder || "",
          account_number: restaurant.account_number || "",
          ifsc: restaurant.ifsc || restaurant.ifsc_code || "",
          bank_mobile: restaurant.bank_mobile || "",
          upi: restaurant.upi || "",
          comission: restaurant.comission || "",
          special_comission: restaurant.special_comission || "",
          min_order: restaurant.min_order || "",
          platform_charge: restaurant.platform_charge || "",
          handling_charge: restaurant.handling_charge || "",
          gst_percentage: restaurant.gst_percentage || "",
          order_receiving_charges: restaurant.order_receiving_charges || "",
          subscription_id: restaurant.subscription_id || "",
          paid: restaurant.paid?.toString() || "",
          wallet: restaurant.wallet || "",
          myreferal: restaurant.myreferal || "",
          refer_by: restaurant.refer_by || "",
          is_mou: restaurant.is_mou?.toString() || "",
          status: restaurant.status === "Active" ? "1" : (restaurant._raw?.status || "0"),
          hide: restaurant.hide || "",
          open_status: restaurant.open_status || "",
          is_ready: restaurant.is_ready || "",
          shift_start: restaurant.shift_start || restaurant.shiftStart || "",
          shift_end: restaurant.shift_end || restaurant.shiftEnd || "",
          is_auto_schedule: restaurant.is_auto_schedule?.toString() || "",
          is_schedule_approved: restaurant.is_schedule_approved?.toString() || "",
          is_verify_personalinfo: restaurant.is_verify_personalinfo?.toString() || "",
          is_verify_docinfo: restaurant.is_verify_docinfo?.toString() || "",
          is_verify_bankinfo: restaurant.is_verify_bankinfo?.toString() || "",
          remarks_personalinfo: restaurant.remarks_personalinfo || "",
          remarks_docinfo: restaurant.remarks_docinfo || "",
          remarks_bankinfo: restaurant.remarks_bankinfo || "",
          is_menu: restaurant.is_menu?.toString() || "",
          isKOT: restaurant.isKOT?.toString() || "",
          isBill: restaurant.isBill?.toString() || "",
          menu_direction: restaurant.menu_direction || "neutral",
          menu_direction_type: restaurant.menu_direction_type || "percentage",
          menu_direction_value: restaurant.menu_direction_value || "",
          details: restaurant.details || "",
          subject: restaurant.subject || "",
          meet_to: restaurant.meet_to || "",
          interestedin: restaurant.interestedin || "",
          gst_number: restaurant.gst_number || "",
          food_license_number: restaurant.food_license_number || "",
          created_by_id: restaurant.created_by_id || "1",
          pic: restaurant.pic || "",
          r_logo: restaurant.r_logo || "",
          h_logo: restaurant.h_logo || "",
          aadhar_front: restaurant.aadhar_front || "",
          aadhar_back: restaurant.aadhar_back || "",
          pan_card: restaurant.pan_card || "",
          gst_pic: restaurant.gst_pic || "",
          food_license_pic: restaurant.food_license_pic || "",
          bank_pass: restaurant.bank_pass || "",
          cancel_cheque: restaurant.cancel_cheque || "",
          current_menu_page1: restaurant.current_menu_page1 || "",
          current_menu_page2: restaurant.current_menu_page2 || "",
          current_menu_page3: restaurant.current_menu_page3 || "",
          current_menu_page4: restaurant.current_menu_page4 || "",
          current_menu_page5: restaurant.current_menu_page5 || "",
          current_menu_page6: restaurant.current_menu_page6 || "",
          current_menu_page7: restaurant.current_menu_page7 || "",
          current_menu_page8: restaurant.current_menu_page8 || "",
          current_menu_page9: restaurant.current_menu_page9 || "",
        }
      }
    });
  };

  const documents = [
    { label: "GST Certificate", icon: <DocumentIcon />, number: restaurant.gst_number || "Not Available", image: restaurant.gst_pic, status: restaurant.gst_number && restaurant.gst_number !== "NULL" ? "Verified" : "Pending" },
    { label: "Food License", icon: <LicenseIcon />, number: restaurant.food_license_number || "Not Available", image: restaurant.food_license_pic, status: restaurant.food_license_number && restaurant.food_license_number !== "NULL" ? "Verified" : "Pending" },
    { label: "PAN Card", icon: <IdCardIcon />, number: restaurant.pan_card || "Not Available", image: restaurant.pan_card, status: restaurant.pan_card && restaurant.pan_card !== "NULL" ? "Verified" : "Pending" },
    { label: "Bank Details", icon: <BankIcon />, number: `${restaurant.bank_name || "Bank"} - ${restaurant.account_number || "Account"}`, image: restaurant.cancel_cheque, status: restaurant.is_verify_bankinfo === "1" ? "Verified" : "Pending" },
   { label: "Restaurant Logo", icon: <ImageIcon />, number: restaurant.organisation_name || "Restaurant Name", image: restaurant.pic, status: restaurant.pic && restaurant.pic !== "NULL" ? "Verified" : "Pending" }
    // { label: "Restaurant Logo", icon: <ImageIcon />, number: restaurant.organisation_name || "Restaurant Name", image: restaurant.pic, status: restaurant.pic && restaurant.pic !== "NULL" ? "Verified" : "Pending" }
  ].filter(doc => doc.image && doc.image !== "NULL" && doc.image !== "null" && doc.image.trim() !== "");

  const theme = isDark ? 'dark' : 'light';

  return (
    <div style={{ minHeight: "100vh", background: isDark ? "#0d1117" : "#f8fafc", fontFamily: "'Inter', sans-serif", overflowX: "hidden" }}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        .offer-table-container {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        .offer-table-container::-webkit-scrollbar {
          height: 4px;
        }
        .offer-table-container::-webkit-scrollbar-track {
          background: ${isDark ? "#1a2035" : "#e2e8f0"};
          border-radius: 10px;
        }
        .offer-table-container::-webkit-scrollbar-thumb {
          background: #3b82f6;
          border-radius: 10px;
        }
        .offer-table {
          min-width: 600px;
          width: 100%;
          border-collapse: collapse;
        }
        .offer-table th {
          position: sticky;
          top: 0;
          background: ${isDark ? "#141824" : "#ffffff"};
          z-index: 1;
        }
      `}</style>
      
      {/* Header */}
      <div style={{
        position: "sticky", top: 0, zIndex: 50,
        background: isDark ? "#0d1117" : "#f8fafc",
        borderBottom: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
        padding: "12px 24px",
        width: "100%",
        overflow: "hidden",
      }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px" }}>
          <button onClick={onBack} style={{ display: "flex", alignItems: "center", gap: "6px", background: "none", border: "none", color: "#3b82f6", cursor: "pointer", fontSize: "12px" }}>
            <BackIcon /> Back
          </button>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <button 
              onClick={handleEditClick} 
              style={{ 
                padding: "6px 16px", 
                borderRadius: "8px", 
                border: "none", 
                background: "#f59e0b", 
                color: "#fff", 
                cursor: "pointer", 
                display: "flex", 
                alignItems: "center", 
                gap: "6px", 
                fontSize: "12px", 
                fontWeight: 500 
              }}
            >
              <EditIcon /> Edit
            </button>
            <button onClick={() => onDelete(restaurant)} style={{ padding: "6px 16px", borderRadius: "8px", border: "none", background: "#ef4444", color: "#fff", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px", fontSize: "12px", fontWeight: 500 }}>
              <TrashIcon /> Delete
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px", overflow: "hidden" }}>
        
        {/* Restaurant Header Card */}
        <div style={{
          background: isDark ? "#141824" : "#ffffff",
          borderRadius: "16px",
          border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
          padding: "20px",
          marginBottom: "20px",
          overflow: "hidden",
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: "16px" }}>
            <div>
              {/* <h1 style={{ fontSize: "24px", fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b", marginBottom: "4px" }}>{restaurant.name}</h1> */}

              <h1 style={{ fontSize: "24px", fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b", marginBottom: "4px" }}>
  {restaurant.organisation_name || restaurant.name || "Restaurant"}
</h1>
              <p style={{ fontSize: "11px", color: "#64748b" }}>ID: {restaurant.restroId || "N/A"}</p>
              <div style={{ display: "flex", gap: "6px", marginTop: "10px", flexWrap: "wrap" }}>
                <StatusBadge status={restaurant.status || "Inactive"} isDark={isDark} />
                <ReadyBadge ready={restaurant.ready || "No"} isDark={isDark} />
                <OnOffBadge value={restaurant.onOff || "OFF"} isDark={isDark} />
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
              {[...Array(5)].map((_, i) => (
                <StarIcon key={i} style={{ color: i < Math.floor(restaurant.rating || 0) ? "#fbbf24" : "#374151", width: "14px", height: "14px" }} />
              ))}
              <span style={{ marginLeft: "6px", fontSize: "11px", color: "#64748b" }}>({restaurant.totalRatings || 0})</span>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div style={{
          display: "flex", gap: "4px", borderBottom: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
          marginBottom: "20px", flexWrap: "wrap",
          overflowX: "auto",
          WebkitOverflowScrolling: "touch",
        }}>
          {[
            { id: "overview", label: "Overview", icon: "🏠" },
            { id: "menu", label: "Menu", icon: "🍽️", onClick: handleMenuTabClick },
            { id: "orders", label: "Orders", icon: "📦", onClick: handleOrdersTabClick },
            { id: "timings", label: "Timings", icon: "⏰" },
            { id: "payments", label: "Payments", icon: "💰" },
            { id: "reviews", label: "Reviews", icon: "⭐" },
            { id: "location", label: "Location", icon: "📍", onClick: handleLocationTabClick },
            { id: "documents", label: "Documents", icon: "📄" },
          ].map(tab => (
            <button key={tab.id} onClick={() => { if (tab.onClick) tab.onClick(); else setActiveTab(tab.id); }} style={{
              display: "flex", alignItems: "center", gap: "6px",
              padding: "8px 16px", background: activeTab === tab.id && !tab.onClick ? (isDark ? "#1e3a8a" : "#3b82f6") : "none",
              border: "none", borderRadius: "8px 8px 0 0", cursor: "pointer",
              color: activeTab === tab.id && !tab.onClick ? "#fff" : (isDark ? "#94a3b8" : "#64748b"),
              fontWeight: activeTab === tab.id && !tab.onClick ? 600 : 500,
              fontSize: "11px", transition: "all 0.2s", whiteSpace: "nowrap",
            }}><span>{tab.icon}</span><span>{tab.label}</span></button>
          ))}
        </div>

        {/* Overview Tab Content */}
        {activeTab === "overview" && (
          <>
            {/* Stats Grid */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "12px", marginBottom: "20px" }}>
              <StatCard value={`⭐ ${restaurant.rating || 0}`} label="Average Rating" icon="⭐" color="#fbbf24" isDark={isDark} />
              <StatCard value={`₹${(restaurant.totalPayments || 0).toLocaleString()}`} label="Total Revenue" icon="💰" color="#10b981" isDark={isDark} />
              <StatCard value="0" label="Pending Orders" icon="📦" color="#f59e0b" isDark={isDark} />
              <StatCard value="0" label="Menu Items" icon="🍽️" color="#8b5cf6" isDark={isDark} />
            </div>

            {/* All Offers Section with Table and Pagination */}
            <div style={{
              background: isDark ? "#141824" : "#ffffff",
              borderRadius: "14px",
              border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
              marginBottom: "20px",
              overflow: "hidden",
            }}>
              <div style={{
                padding: "12px 16px",
                borderBottom: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
                background: isDark ? "#0f1520" : "#f8fafc",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "10px",
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <TagIcon style={{ width: "16px", height: "16px", color: "#3b82f6" }} />
                  <div>
                    <h3 style={{ fontSize: "14px", fontWeight: 600, color: isDark ? "#f1f5f9" : "#1e293b", margin: 0 }}>All Offers</h3>
                    <p style={{ fontSize: "10px", color: "#64748b", margin: 0 }}>{allOffers.length} total offer{allOffers.length !== 1 ? 's' : ''}</p>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                  <input
                    type="text"
                    placeholder="Search offers..."
                    value={offerSearch}
                    onChange={(e) => { setOfferSearch(e.target.value); setCurrentPage(1); }}
                    style={{
                      padding: "4px 10px",
                      borderRadius: "6px",
                      border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
                      background: isDark ? "#0f1520" : "#f8fafc",
                      color: isDark ? "#f1f5f9" : "#1e293b",
                      fontSize: "11px",
                      outline: "none",
                      width: "130px",
                    }}
                  />
                  <button onClick={handleGoToOffers} style={{
                    padding: "5px 12px", borderRadius: "6px", border: "none",
                    background: "#3b82f6", color: "#fff", cursor: "pointer",
                    fontSize: "11px", fontWeight: 500, display: "flex", alignItems: "center", gap: "4px",
                  }}><PlusIcon style={{ width: "12px", height: "12px" }} /> Create</button>
                </div>
              </div>
              
              <div style={{ padding: "12px", overflowX: "hidden" }}>
                {loadingOffers ? (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "30px" }}>
                    <SpinnerIcon /> <span style={{ marginLeft: "8px", fontSize: "12px", color: "#64748b" }}>Loading offers...</span>
                  </div>
                ) : offerError ? (
                  <div style={{ textAlign: "center", padding: "20px" }}>
                    <p style={{ fontSize: "11px", color: "#ef4444" }}>{offerError}</p>
                    <button onClick={fetchAllOffers} style={{ marginTop: "8px", padding: "4px 12px", borderRadius: "6px", border: "none", background: "#3b82f6", color: "#fff", cursor: "pointer", fontSize: "10px" }}>Retry</button>
                  </div>
                ) : allOffers.length === 0 ? (
                  <div style={{ textAlign: "center", padding: "20px" }}>
                    <TagIcon style={{ width: "32px", height: "32px", color: "#64748b", marginBottom: "8px", opacity: 0.5 }} />
                    <p style={{ fontSize: "12px", color: "#64748b" }}>No offers created yet</p>
                    <p style={{ fontSize: "10px", color: "#64748b" }}>Create your first offer to attract more customers</p>
                  </div>
                ) : (
                  <>
                    <div className="offer-table-container">
                      <table className="offer-table">
                        <thead>
                          <tr style={{
                            borderBottom: `2px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
                            background: isDark ? "#0f1520" : "#f8fafc",
                          }}>
                            <th style={{ padding: "6px 10px", textAlign: "center", fontSize: "10px", fontWeight: 700, color: "#3b82f6", width: "40px" }}>#</th>
                            <th style={{ padding: "6px 10px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: "#3b82f6" }}>Offer Name</th>
                            <th style={{ padding: "6px 10px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: "#3b82f6" }}>Type</th>
                            <th style={{ padding: "6px 10px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: "#3b82f6" }}>Discount</th>
                            <th style={{ padding: "6px 10px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: "#3b82f6" }}>Start Date</th>
                            <th style={{ padding: "6px 10px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: "#3b82f6" }}>End Date</th>
                            <th style={{ padding: "6px 10px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: "#3b82f6" }}>Status</th>
                            <th style={{ padding: "6px 10px", textAlign: "right", fontSize: "10px", fontWeight: 700, color: "#3b82f6" }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedOffers.map((offer, idx) => (
                            <OfferTableRow 
                              key={offer.id} 
                              offer={offer} 
                              index={startIndex + idx} 
                              theme={theme} 
                              onEdit={handleEditOffer} 
                              onDelete={handleDeleteOffer} 
                            />
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination Controls */}
                    {filteredOffers.length > rowsPerPage && (
                      <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "12px 0 0 0",
                        borderTop: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
                        marginTop: "12px",
                        flexWrap: "wrap",
                        gap: "10px",
                      }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "12px", color: isDark ? "#94a3b8" : "#6b7280" }}>
                          <span>Rows:</span>
                          <select
                            value={rowsPerPage}
                            onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                            style={{
                              padding: "4px 8px",
                              borderRadius: "6px",
                              border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
                              background: isDark ? "#0f1520" : "#f8fafc",
                              color: isDark ? "#f1f5f9" : "#1e293b",
                              fontSize: "11px",
                              cursor: "pointer",
                              outline: "none",
                            }}
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                          </select>
                          <span>
                            {startIndex + 1} - {Math.min(startIndex + rowsPerPage, filteredOffers.length)} of {filteredOffers.length}
                          </span>
                        </div>
                        <div style={{ display: "flex", gap: "4px" }}>
                          <button
                            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                            disabled={currentPage === 1}
                            style={{
                              padding: "4px 10px",
                              borderRadius: "6px",
                              border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
                              background: isDark ? "#0f1520" : "#f8fafc",
                              color: currentPage === 1 ? (isDark ? "#3a4460" : "#cbd5e1") : (isDark ? "#94a3b8" : "#64748b"),
                              cursor: currentPage === 1 ? "not-allowed" : "pointer",
                              fontSize: "11px",
                              transition: "all 0.2s",
                              opacity: currentPage === 1 ? 0.5 : 1,
                            }}
                          >
                            Previous
                          </button>
                          <span style={{
                            padding: "4px 12px",
                            borderRadius: "6px",
                            background: "#3b82f6",
                            color: "#fff",
                            fontSize: "11px",
                            fontWeight: 600,
                          }}>
                            {currentPage} / {totalPages}
                          </span>
                          <button
                            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                            disabled={currentPage === totalPages}
                            style={{
                              padding: "4px 10px",
                              borderRadius: "6px",
                              border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
                              background: isDark ? "#0f1520" : "#f8fafc",
                              color: currentPage === totalPages ? (isDark ? "#3a4460" : "#cbd5e1") : (isDark ? "#94a3b8" : "#64748b"),
                              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                              fontSize: "11px",
                              transition: "all 0.2s",
                              opacity: currentPage === totalPages ? 0.5 : 1,
                            }}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>

            {/* Info Cards */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "16px", marginBottom: "16px" }}>
              <div style={{ background: isDark ? "#141824" : "#ffffff", borderRadius: "14px", border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, overflow: "hidden" }}>
                <div style={{ padding: "10px 16px", borderBottom: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, background: isDark ? "#0f1520" : "#f8fafc" }}>
                  <h3 style={{ fontSize: "13px", fontWeight: 600, color: isDark ? "#f1f5f9" : "#1e293b", margin: 0 }}>Contact Information</h3>
                </div>
                <div style={{ padding: "12px", display: "flex", flexDirection: "column", gap: "8px" }}>
                  <InfoRow label="Phone" value={restaurant.contact || "Not specified"} icon={<PhoneIcon />} isDark={isDark} />
                  <InfoRow label="Email" value={restaurant.email || "Not specified"} icon={<EmailIcon />} isDark={isDark} />
                  <InfoRow label="Location" value={restaurant.address || "Not specified"} icon={<LocationIcon />} isDark={isDark} />
                </div>
              </div>

              <div style={{ background: isDark ? "#141824" : "#ffffff", borderRadius: "14px", border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, overflow: "hidden" }}>
                <div style={{ padding: "10px 16px", borderBottom: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, background: isDark ? "#0f1520" : "#f8fafc" }}>
                  <h3 style={{ fontSize: "13px", fontWeight: 600, color: isDark ? "#f1f5f9" : "#1e293b", margin: 0 }}>Business Hours</h3>
                </div>
                <div style={{ padding: "12px", display: "flex", flexDirection: "column", gap: "8px" }}>
                  <InfoRow label="Opening Time" value={restaurant.shiftStart || "10:00 AM"} icon={<ClockIcon />} isDark={isDark} />
                  <InfoRow label="Closing Time" value={restaurant.shiftEnd || "11:00 PM"} icon={<ClockIcon />} isDark={isDark} />
                  <button onClick={onViewSchedule} style={{ marginTop: "4px", padding: "6px", borderRadius: "8px", border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, background: isDark ? "#0f1520" : "#f8fafc", color: "#3b82f6", cursor: "pointer", fontSize: "11px", display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
                    <ClockIcon /> Edit Timings
                  </button>
                </div>
              </div>
            </div>

            {/* About Restaurant */}
            <div style={{ background: isDark ? "#141824" : "#ffffff", borderRadius: "14px", border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, padding: "16px" }}>
              <h3 style={{ fontSize: "13px", fontWeight: 600, color: isDark ? "#f1f5f9" : "#1e293b", marginBottom: "8px" }}>About Restaurant</h3>
              <p style={{ fontSize: "12px", lineHeight: "1.5", color: isDark ? "#94a3b8" : "#475569", marginBottom: "10px" }}>
                {restaurant.description || "No description available"}
              </p>
              <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "4px 10px", background: isDark ? "#0f1520" : "#f1f5f9", borderRadius: "16px" }}>
                <span style={{ fontSize: "10px", color: "#64748b" }}>Cuisine:</span>
                <span style={{ fontSize: "11px", fontWeight: 500, color: isDark ? "#f1f5f9" : "#1e293b" }}>{restaurant.cuisine || "Multi-cuisine"}</span>
              </div>
            </div>
          </>
        )}

        {/* Documents Tab */}
        {activeTab === "documents" && (
          <div style={{ background: isDark ? "#141824" : "#ffffff", borderRadius: "14px", border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, padding: "20px", overflow: "hidden" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
              <DocumentIcon style={{ color: "#3b82f6" }} />
              <h3 style={{ fontSize: "15px", fontWeight: 600, color: isDark ? "#f1f5f9" : "#1e293b", margin: 0 }}>All Documents & Certificates</h3>
            </div>
            {documents.length === 0 ? (
              <div style={{ textAlign: "center", padding: "40px", color: isDark ? "#64748b" : "#9ca3af" }}>
                <DocumentIcon style={{ width: "40px", height: "40px", marginBottom: "12px", opacity: 0.5 }} />
                <p style={{ fontSize: "12px" }}>No documents uploaded yet</p>
              </div>
            ) : (
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: "12px" }}>
                {documents.map((doc, idx) => <DocumentCard key={idx} document={doc} theme={theme} />)}
              </div>
            )}
          </div>
        )}

        {/* Timings Tab */}
        {activeTab === "timings" && (
          <div style={{ background: isDark ? "#141824" : "#ffffff", borderRadius: "14px", border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, padding: "24px", textAlign: "center" }}>
            <div style={{ display: "flex", justifyContent: "center", gap: "32px", flexWrap: "wrap", marginBottom: "20px" }}>
              <div><div style={{ fontSize: "11px", color: "#64748b", marginBottom: "4px" }}>Opening Time</div><div style={{ fontSize: "24px", fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b" }}>{restaurant.shiftStart || "10:00 AM"}</div></div>
              <div><div style={{ fontSize: "11px", color: "#64748b", marginBottom: "4px" }}>Closing Time</div><div style={{ fontSize: "24px", fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b" }}>{restaurant.shiftEnd || "11:00 PM"}</div></div>
            </div>
            <button onClick={onViewSchedule} style={{ padding: "8px 20px", borderRadius: "8px", border: "none", background: "#3b82f6", color: "#fff", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "12px" }}>
              <ClockIcon /> Edit Timings
            </button>
          </div>
        )}

        {/* Payments Tab */}
        {activeTab === "payments" && (
          <div style={{ background: isDark ? "#141824" : "#ffffff", borderRadius: "14px", border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, padding: "20px" }}>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "12px" }}>
              <div style={{ textAlign: "center", padding: "16px", background: isDark ? "#0f1520" : "#f8fafc", borderRadius: "10px" }}>
                <div style={{ fontSize: "24px", fontWeight: 700, color: "#3b82f6" }}>₹{paymentSummary.total.toLocaleString()}</div>
                <div style={{ fontSize: "10px", color: "#64748b" }}>Total Revenue</div>
              </div>
              <div style={{ textAlign: "center", padding: "16px", background: isDark ? "#0f1520" : "#f8fafc", borderRadius: "10px" }}>
                <div style={{ fontSize: "24px", fontWeight: 700, color: "#10b981" }}>₹{paymentSummary.completed.toLocaleString()}</div>
                <div style={{ fontSize: "10px", color: "#64748b" }}>Completed</div>
              </div>
              <div style={{ textAlign: "center", padding: "16px", background: isDark ? "#0f1520" : "#f8fafc", borderRadius: "10px" }}>
                <div style={{ fontSize: "24px", fontWeight: 700, color: "#f59e0b" }}>₹{paymentSummary.pending.toLocaleString()}</div>
                <div style={{ fontSize: "10px", color: "#64748b" }}>Pending</div>
              </div>
              <div style={{ textAlign: "center", padding: "16px", background: isDark ? "#0f1520" : "#f8fafc", borderRadius: "10px" }}>
                <div style={{ fontSize: "24px", fontWeight: 700, color: "#8b5cf6" }}>₹{paymentSummary.platformFee.toLocaleString()}</div>
                <div style={{ fontSize: "10px", color: "#64748b" }}>Platform Fee</div>
              </div>
            </div>
          </div>
        )}

        {/* Reviews Tab */}
        {activeTab === "reviews" && (
          <div style={{ background: isDark ? "#141824" : "#ffffff", borderRadius: "14px", border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, padding: "32px", textAlign: "center" }}>
            <div style={{ fontSize: "40px", marginBottom: "12px" }}>⭐</div>
            <div style={{ fontSize: "32px", fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b", marginBottom: "4px" }}>{restaurant.rating || 0}</div>
            <div style={{ fontSize: "11px", color: "#64748b", marginBottom: "16px" }}>Average rating from {restaurant.totalRatings || 0} ratings</div>
            <div style={{ fontSize: "11px", color: "#64748b" }}>{restaurant.totalReviews || 0} total reviews</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RestaurantDetailPage;